module.exports = __webpack_public_path__ + "img/PXL_20230526_091558096.8543d80e.jpg";